import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RegistrationComponent } from './registration/registration.component';
import { LoginComponent } from './login/login.component';
import { AuthInterceptor } from './auth/auth.interceptor';
import { DashBoardComponent } from './admin/dashboard/dashboard.component';
import { ErrorComponent } from './error/error.component';
import { HeaderComponent } from './admin/shared/header/header.component';
import { SideBarLeftComponent } from './admin/shared/sidebar-left/sidebar-left.component';
import { SideBarRightComponent } from './admin/shared/sidebar-right/sidebar-right.component';
import { BaseService } from './service/base.service';
import { NgxPermissionsModule } from 'ngx-permissions';
import { RoleComponent } from './admin/auth/role/role.component';
import { RolePermissionComponent } from './admin/auth/role-permission/role-permission.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { UserRoleComponent } from './admin/auth/user-role/user-role.component';
import { UserComponent } from './admin/auth/user/user.component';
import { UserEditComponent } from './admin/auth/user/edit/user-edit.component';
import { EduCategoryComponent } from './admin/context/edu/edu-category/edu-category.component';
import { EduCategoryEditComponent } from './admin/context/edu/edu-category/edit/edu-category-edit.component';
import { EduProjectComponent } from './admin/context/edu/edu-project/edu-project.component';
import { EduProjectEditComponent } from './admin/context/edu/edu-project/edit/edu-project-edit.component';
import { NgxTreeSelectModule } from 'custom-tree-select';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { NgxCurrencyModule } from "ngx-currency";
import { UploaderModule } from '@syncfusion/ej2-angular-inputs';
import { ModalModule, BsModalService } from 'ngx-bootstrap/modal';
import { PayAccountVNPComponent } from './admin/context/pay/pay-account-vnp/pay-account-vnp.component';
import { ForgotPassComponent } from './forgot-pass/forgot-pass.component';
import { ResetPassComponent } from './reset-pass/reset-pass.component';
import { PayTransactionVNPRechargeComponent } from './admin/context/pay/pay-transaction-vnp-recharge/pay-transaction-vnp-recharge.component';
import { DatePipe } from '@angular/common';
import { PayTransactionVNPRetailComponent } from './admin/context/pay/pay-transaction-vnp-retail/pay-transaction-vnp-retail.component';
import { NgxMatDatetimePickerModule, NgxMatTimepickerModule, NgxMatNativeDateModule } from '@angular-material-components/datetime-picker';
import { MatButtonModule, MatDatepickerModule, MatInputModule } from '@angular/material';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTabsModule } from '@angular/material/tabs';
import { EduBannerComponent } from './admin/context/edu/edu-banner/edu-banner.component';
import { EduBannerEditComponent } from './admin/context/edu/edu-banner/edit/edu-banner-edit.component';
import { EduBlogComponent } from './admin/context/edu/edu-blog/edu-blog.component';
import { EduBlogEditComponent } from './admin/context/edu/edu-blog/edit/edu-blog-edit.component';
import { PayWithdrawalRequestComponent } from './admin/context/pay/pay-withdrawal-request/pay-withdrawal-request.component';
import { PayWithdrawalRequestEditComponent } from './admin/context/pay/pay-withdrawal-request/edit/pay-withdrawal-request-edit.component';
import { EduProjectErrorComponent } from './admin/context/edu/edu-project-error/edu-project-error.component';
import { EduProjectErrorEditComponent } from './admin/context/edu/edu-project-error/edit/edu-project-error-edit.component';
import { EduProjectViolationComponent } from './admin/context/edu/edu-project-violation/edu-project-violation.component';
import { EduProjectViolationEditComponent } from './admin/context/edu/edu-project-violation/edit/edu-project-violation-edit.component';
import { EduProjectCommentComponent } from './admin/context/edu/edu-project-comment/edu-project-comment.component';
import { EduProjectCommentEditComponent } from './admin/context/edu/edu-project-comment/edit/edu-project-comment-edit.component';

@NgModule({
	declarations: [
		// Directive

		// Shared
		AppComponent,
		ErrorComponent,
		HeaderComponent,
		SideBarLeftComponent,
		SideBarRightComponent,

		DashBoardComponent,
		RegistrationComponent,
		LoginComponent,
		ForgotPassComponent,
		ResetPassComponent,

		// Auth
		RoleComponent,
		RolePermissionComponent,
		UserRoleComponent,
		UserComponent,
		UserEditComponent,

		// Context - Edu
		EduCategoryComponent,
		EduCategoryEditComponent,
		EduProjectComponent,
		EduProjectEditComponent,
		EduBannerComponent,
		EduBannerEditComponent,
		EduBlogComponent,
		EduBlogEditComponent,

		// Context - Pay
		PayAccountVNPComponent,
		PayTransactionVNPRechargeComponent,
		PayTransactionVNPRetailComponent,
		PayWithdrawalRequestComponent,
		PayWithdrawalRequestEditComponent,
		EduProjectErrorComponent,
		EduProjectErrorEditComponent,
		EduProjectViolationComponent,
		EduProjectViolationEditComponent,
		EduProjectCommentComponent,
		EduProjectCommentEditComponent,
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		ReactiveFormsModule,
		HttpClientModule,
		BrowserAnimationsModule,
		ToastrModule.forRoot({
			progressBar: false,
			enableHtml: true,
		}),
		FormsModule,
		NgxPermissionsModule.forRoot(),
		NgxSpinnerModule,
		NgxTreeSelectModule.forRoot({
			allowFilter: true,
			filterPlaceholder: 'Type your filter here...',
			maxVisibleItemCount: 5,
			idField: 'guid',
			textField: 'name',
			childrenField: 'children',
			expandMode: 'Selection'
		}),
		AngularEditorModule,
		NgxCurrencyModule,
		UploaderModule,
		ModalModule.forRoot(),
		NgxMatDatetimePickerModule,
		NgxMatTimepickerModule,
		MatDatepickerModule,
		MatInputModule,
		MatButtonModule,
		NgxMatNativeDateModule,
		MatAutocompleteModule,
		MatTabsModule,
		NgxChartsModule,
	],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AuthInterceptor,
			multi: true
		},
		DatePipe,
		BaseService,
		BsModalService,
	],
	bootstrap: [AppComponent]
})
export class AppModule { }